"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@formily/react");
var SchemaField_1 = require("./SchemaField");
var useSchemaForm_1 = require("../hooks/useSchemaForm");
var context_1 = require("../shared/context");
var shared_1 = require("@formily/shared");
exports.SchemaForm = function (props) {
    var _a = useSchemaForm_1.useSchemaForm(props), fields = _a.fields, virtualFields = _a.virtualFields, formComponent = _a.formComponent, formItemComponent = _a.formItemComponent, formComponentProps = _a.formComponentProps, schema = _a.schema, form = _a.form, children = _a.children;
    return (react_1.default.createElement(context_1.FormComponentsContext.Provider, { value: { fields: fields, virtualFields: virtualFields, formComponent: formComponent, formItemComponent: formItemComponent } },
        react_1.default.createElement(context_1.FormExpressionScopeContext.Provider, { value: props.expressionScope },
            react_1.default.createElement(context_1.FormSchemaContext.Provider, { value: schema },
                react_1.default.createElement(react_2.Form, { form: form }, react_1.default.createElement(formComponent, __assign(__assign({}, formComponentProps), { onSubmit: function (e) {
                        if (e && e.preventDefault)
                            e.preventDefault();
                        form.submit().catch(function (e) { return shared_1.log.warn(e); });
                    }, onReset: function () {
                        form.reset({ validate: false, forceClear: false });
                    } }), react_1.default.createElement(SchemaField_1.SchemaField, { schema: schema, path: '' }), children))))));
};
exports.SchemaForm.defaultProps = {
    schema: {}
};
exports.default = exports.SchemaForm;
